module.exports = __webpack_public_path__ + "static/media/ios-funnel.5ef19496.svg";